import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ScholarshipSessionActions from './scholarshipsession.actions';
import { ScholarshipSessionService } from '../../services/scholarshipsession.service';

@Injectable()
export class ScholarshipSessionEffects {
  loadScholarshipSession$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipSessionActions.loadScholarshipSession),
      exhaustMap((_) =>
        this.scholarshipSessionService.getScholarshipSession().pipe(
          map((data) =>
            ScholarshipSessionActions.loadScholarshipSessionSuccess({
              scholarshipSession: data,
            })
          ),
          catchError((error) =>
            of(
              ScholarshipSessionActions.loadScholarshipSessionFailure({ error })
            )
          )
        )
      )
    )
  );

  addScholarshipSession$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipSessionActions.addScholarshipSession),
      concatMap(({ newScholarshipSession }) =>
        this.scholarshipSessionService
          .createScholarshipSession(newScholarshipSession)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return ScholarshipSessionActions.addScholarshipSessionSuccess({
                newScholarshipSession: data,
              });
            }),
            catchError((error) =>
              of(
                ScholarshipSessionActions.addScholarshipSessionFailure({
                  error: error.error.message,
                })
              )
            )
          )
      )
    )
  );

  updateScholarshipSession$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipSessionActions.updateScholarshipSession),
      map((action) => action.updateScholarshipSession),
      concatMap((updateScholarshipSession) =>
        this.scholarshipSessionService
          .updateScholarshipSession(updateScholarshipSession)
          .pipe(
            map((_) => {
              this.notification.success('Updated Successfully');
              return ScholarshipSessionActions.updateScholarshipSessionSuccess({
                updateScholarshipSession: updateScholarshipSession,
              });
            }),
            catchError((error) =>
              of(
                ScholarshipSessionActions.updateScholarshipSessionFailure({
                  error: error.message,
                })
              )
            )
          )
      )
    )
  );

  removeScholarshipSession$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipSessionActions.removeScholarshipSession),
      map((action) => action.ids),
      concatMap((ids) =>
        this.scholarshipSessionService.deleteScholarshipSession(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return ScholarshipSessionActions.removeScholarshipSessionSuccess({
              ids,
            });
          }),
          catchError((error) =>
            of(
              ScholarshipSessionActions.updateScholarshipSessionFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private scholarshipSessionService: ScholarshipSessionService,
    private notification: NotificationService
  ) {}
}
